/**
 * Utility functions for table column management
 */

/**
 * Calculates the left position value for fixed columns
 * @param {Array} columnWidths - Array of column widths
 * @param {number} colIndex - Current column index
 * @param {number} checkboxWidth - Width of checkbox column (default: 48)
 * @param {number} slNoWidth - Width of Sl No column (default: 64)
 * @param {boolean} showCheckbox - Whether checkbox column is shown
 * @param {boolean} showSlNo - Whether Sl No column is shown
 * @returns {number} - Left position value in pixels
 */
export const calculateLeftValue = (columnWidths, colIndex, checkboxWidth = 48, slNoWidth = 64, showCheckbox = true, showSlNo = true) => {
  // Checkbox column
  if (colIndex === -2) return 0;
  
  let leftValue = 0;
  
  // Sl No column position depends on whether checkbox is shown
  if (colIndex === -1) {
    return showCheckbox ? checkboxWidth : 0;
  }
  
  // For data columns, add up all preceding columns
  if (showCheckbox) leftValue += checkboxWidth;
  if (showSlNo) leftValue += slNoWidth;
  
  // Add widths of all previous data columns
  for (let i = 0; i < colIndex; i++) {
    leftValue += columnWidths[i] || 100; // Default to 100px if width not available
  }
  
  return leftValue;
};

/**
 * Determines if a column should be fixed based on its index and fixedCol setting
 * @param {number} colIndex - Column index (-2 for checkbox, -1 for Sl No, 0+ for data columns)
 * @param {number} fixedCol - Number of columns to fix (0 means no fixed columns)
 * @returns {boolean} - Whether the column should be fixed
 */
export const isColumnFixed = (colIndex, fixedCol) => {
  // Always fix checkbox and Sl No columns if any columns are fixed
  if (fixedCol > 0 && (colIndex === -2 || colIndex === -1)) {
    return true;
  }
  
  // Fix data columns based on fixedCol setting
  return colIndex >= 0 && colIndex < fixedCol;
};